module.exports = __webpack_public_path__ + "img/about-tile-bg.f1d806a6.png";